module.exports = __webpack_public_path__ + "static/media/elementor.d4d9ffc1.svg";